import { component$, useSignal, useTask$ } from "@builder.io/qwik";
import { cn } from "~/lib/cn";
import { micromark } from "micromark";

export const MarkdownContent = component$(
  (props: { content: string | null | undefined; class?: string }) => {
    const html = useSignal<string | null>(null);

    useTask$(async () => {
      if (props.content) {
        html.value = micromark(props.content);
      }
    });

    return (
      <div
        class={cn("prose", props.class)}
        dangerouslySetInnerHTML={html.value ?? ""}
      />
    );
  },
);
